import {Component, HostListener, OnInit} from '@angular/core';
import {AuthService} from '@auth0/auth0-angular';
import {StoreService} from './shared/store/store.service';
import {LoginService} from './services/login.service';
import {Router} from '@angular/router';
import {AboutRecordDialogService} from 'services/about-record/about-record-dialog.service';
import { AboutRecordAnyDialogDialogService } from './services/about-record/about-record-any-data.service';

@Component({
  selector: 'app-component',
  standalone: false,
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  title = 'tcmr-frontend';

  constructor(
    private readonly auth: AuthService,
    private readonly storeService: StoreService,
    private readonly loginService: LoginService,
    private readonly router: Router,
    private readonly aboutRecordDialogService: AboutRecordDialogService,
    private readonly aboutRecordAnyDataDialogService: AboutRecordAnyDialogDialogService<unknown>
  ) {
  }

  ngOnInit(): void {
    // Initialize store data when user is authenticated
    this.auth.isAuthenticated$.subscribe((isAuthenticated: boolean) => {
      if (isAuthenticated) {
        this.storeService.refreshOrganizationStore();
      }
    });

    // Handle redirection after login
    this.auth.appState$.subscribe((state) => {
      if (state?.target) {
        this.loginService.refreshUserData();
        this.router.navigate([state.target]);
      }
    });
  }

  @HostListener('window:keydown.control.b', ['$event'])
  onGlobalShortcut(event: KeyboardEvent) {
    if (this.shouldIgnoreShortcut(event)) {
      return;
    }

    event.preventDefault();

    if (this.aboutRecordDialogService.active)
      this.aboutRecordDialogService.open();
    else { this.aboutRecordAnyDataDialogService.open(); }
  }

  private shouldIgnoreShortcut(event: KeyboardEvent): boolean {
    const target = event.target as HTMLElement | null;
    if (!target) {
      return false;
    }

    const tagName = target.tagName?.toLowerCase();
    return (
      tagName === 'input' ||
      tagName === 'textarea' ||
      target.isContentEditable ||
      target.getAttribute('role') === 'textbox'
    );
  }
}
